<!-- No title — the provider shell above the tab strip names the page. -->
<app-grid-page>
  <ng-container *transloco="let t; read: 'providers.feedsGrid'">
    <app-grid
      [columns]="columns()"
      [data]="feeds()"
      [rowId]="feedId"
      [loading]="isLoading()"
      [totalElements]="feeds().length"
      [totalPages]="1"
      [searchable]="true"
      [primaryAction]="primaryAction()"
      [rowActions]="rowActions()"
      (searchChange)="onSearchChange($event)"
      (rowClick)="onRowClick(asFeed($event))"
      (rowActionClick)="onRowAction($event.actionId, asFeed($event.row))"
      (primaryActionClick)="addFeed()"
    >
      <ng-template gridCell="name" let-row>
        @let feed = asFeed(row);
        <div class="flex min-w-0 flex-col">
          <span class="truncate text-sm font-semibold text-ink-1">{{ feed.name }}</span>
          <span class="truncate text-xs text-ink-3">{{ subtitle(feed) }}</span>
        </div>
      </ng-template>

      <ng-template gridCell="realtime" let-row>
        @if (isRealtime(asFeed(row))) {
          <app-label-badge dot="green">{{ t('realtimeOn') }}</app-label-badge>
        } @else {
          <app-label-badge>{{ t('realtimeOff') }}</app-label-badge>
        }
      </ng-template>

      <ng-template gridCell="status" let-row>
        @let feed = asFeed(row);
        <span [attr.title]="statusMessage(feed)">
          <app-label-badge [dot]="statusDot(feed)">{{ statusLabel(feed) }}</app-label-badge>
        </span>
      </ng-template>

      <ng-template gridCell="health" let-row>
        @let feed = asFeed(row);
        @if (isDiagnosticsLoading()) {
          <span class="text-sm text-ink-3">—</span>
        } @else {
          @let h = health(feed);
          @let age = snapshotAge(feed);
          <div class="flex min-w-0 flex-col gap-1">
            @if (h) {
              <span [attr.title]="h.message">
                <app-label-badge [dot]="healthDot(h)">{{ t('health.' + h.status) }}</app-label-badge>
              </span>
              @if (h.status !== 'OK') {
                <span class="truncate text-xs text-ink-2" [attr.title]="h.message">{{ h.message }}</span>
              }
            } @else {
              <app-label-badge>{{ t('health.none') }}</app-label-badge>
            }
            @if (age) {
              <span class="truncate text-xs" [class.text-danger]="age.stale" [class.text-ink-3]="!age.stale">{{ age.age }}</span>
            }
          </div>
        }
      </ng-template>
    </app-grid>
  </ng-container>
</app-grid-page>
